"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    text-wrap: none;\n    white-space: nowrap;\n    word-wrap: normal;\n    text-align: left;\n    cursor: pointer;\n    transition-property: background, color;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var _ref2;

  var theme = _ref.theme;
  var palette = theme.palette;
  return _ref2 = {
    color: theme.itemColor,
    backgroundColor: theme.itemBackground,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    paddingBottom: theme.itemPaddingBottom,
    paddingTop: theme.itemPaddingTop,
    paddingLeft: theme.itemPaddingLeft,
    paddingRight: theme.itemPaddingRight
  }, (0, _defineProperty2["default"])(_ref2, '&:focus', {
    background: theme.focusItemBackground,
    color: theme.focusItemColor
  }), (0, _defineProperty2["default"])(_ref2, '&:hover', {
    background: theme.hoverItemBackground,
    color: theme.hoverItemColor
  }), (0, _defineProperty2["default"])(_ref2, '&:active', {
    background: theme.activeItemBackground,
    color: theme.activeItemColor
  }), _ref2;
};

var Item = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Item;
exports["default"] = _default;